import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActions,
} from '@mui/material';
import { categoryColors } from '../constants';

const getTextColor = (backgroundColor) => {
  if (!backgroundColor || typeof backgroundColor !== 'string') {
    // console.error("backgroundColor is not a valid string:", backgroundColor);
    return 'black';
  }

  const rgb = parseInt(backgroundColor.slice(1), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luma > 128 ? 'black' : 'white';
};

const WorkshopCard = ({ workshop, onEdit, onDelete, role, onApprove }) => {
  const categoryColor = categoryColors[workshop.category];
  const textColor = getTextColor(categoryColor);

  return (
    <Card
      sx={{
        mb: '10px',
        backgroundColor: categoryColor,
        borderLeft:
          workshop.isApproved === false ? '6px solid #FF9800' : 'none',
      }}
    >
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor }}>
          {workshop.title}
        </Typography>
        {workshop.isApproved === false && (
          <Typography
            variant="caption"
            sx={{
              color: textColor,
              fontWeight: 'bold',
              backgroundColor: '#FF9800',
              borderRadius: '4px',
              p: '2px 6px',
              display: 'inline-block',
              mb: '4px',
            }}
          >
            ⏳ Oczekuje na zatwierdzenie ⏳
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: textColor }}>
          <strong>
            {workshop.endTime
              ? `${workshop.startTime} - ${workshop.endTime}`
              : workshop.startTime}
          </strong>
        </Typography>
        <Typography variant="body2" sx={{ color: textColor }}>
          {workshop.description}
        </Typography>
        {workshop.location && (
          <Typography variant="body2" sx={{ color: textColor }}>
            <strong>Miejsce: </strong>
            {workshop.location}
          </Typography>
        )}
        {workshop.instructor && (
          <Typography variant="body2" sx={{ color: textColor }}>
            <strong>Prowadzący:</strong> {workshop.instructor}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: textColor }}>
          {workshop.category}
        </Typography>
      </CardContent>
      {role === 'organizer' && (
        <CardActions>
          <Button
            size="small"
            sx={{ color: textColor, minWidth: 0 }}
            onClick={onEdit}
          >
            Edytuj
          </Button>
          <Button
            size="small"
            sx={{ color: textColor, minWidth: 0 }}
            onClick={onDelete}
          >
            Usuń
          </Button>
          {workshop.isApproved === false && (
            <Button
              size="small"
              sx={{ color: textColor, minWidth: 0 }}
              onClick={onApprove}
            >
              Zatwierdź
            </Button>
          )}
        </CardActions>
      )}
    </Card>
  );
};

export default WorkshopCard;
